// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__g0PBw","error":"styles_error__vkDiM","selection":"styles_selection__HA7Vg","submit":"styles_submit__MgJ3R"};